/**
 * @file コンポーネント：フル動画ページ リンクボタン DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Button } from "~/src/components/uiparts/Button";

// スタイル読み込み
import { StyledContents } from "./style";

// 関数読み込み
import { fnReplaceLocalizedText } from "~/src/functions/common";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledContents>
            <Button
                buttonType="main"
                href={props.contentPageLink}
                text={props.contentPageLinkButtonText}
                title={localized["Label.ViewDocument"]}
                icon={
                    props.contentPageLinkAnotherTabFlag ? (
                        <i className="fas fa-external-link-alt" />
                    ) : null
                }
                target={props.contentPageLinkAnotherTabFlag ? "_blank" : undefined}
                rel={props.contentPageLinkAnotherTabFlag ? "noopener noreferrer" : undefined}
            />
        </StyledContents>
    );
};
